<script>
    import Map from './map/Map.svelte';
    import Traces from './map/Traces.svelte';

    export let dataKey;
</script>

<div>
    <div class="row card">
        <Map {dataKey} />
        <Traces {dataKey} />
    </div>
</div>
